/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AccessRule
 */
export interface AccessRule {
  /**
   *
   * @type {number}
   * @memberof AccessRule
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof AccessRule
   */
  readonly url: string;
  /**
   *
   * @type {string}
   * @memberof AccessRule
   */
  email: string;
  /**
   *
   * @type {boolean}
   * @memberof AccessRule
   */
  writeAccess?: boolean;
}

/**
 * Check if a given object implements the AccessRule interface.
 */
export function instanceOfAccessRule(value: object): value is AccessRule {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("url" in value) || value["url"] === undefined) return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  return true;
}

export function AccessRuleFromJSON(json: any): AccessRule {
  return AccessRuleFromJSONTyped(json, false);
}

export function AccessRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRule {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    url: json["url"],
    email: json["email"],
    writeAccess: json["write_access"] == null ? undefined : json["write_access"],
  };
}

export function AccessRuleToJSON(json: any): AccessRule {
  return AccessRuleToJSONTyped(json, false);
}

export function AccessRuleToJSONTyped(
  value?: Omit<AccessRule, "id" | "url"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    email: value["email"],
    write_access: value["writeAccess"],
  };
}
